import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { StatusTrackingDto } from '../../../shared/modules/status-tracking/dtos/status-tracking.dto';
import { VehicleMakeListDto } from '../../../shared/modules/vehicle-makes/dtos/vehicle-make-list.dto';
import { VehicleModelListDto } from '../../../shared/modules/vehicle-models/dtos/vehicle-model-list.dto';
import { LocationListDto } from '../../locations/dtos/location-list.dto';
import { SupplierListDto } from '../../suppliers/dtos/supplier-list.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategoryListDto } from '../../vehicle-categories/dtos/vehicle-category-list.dto';
import { VehicleColorListDto } from '../../vehicle-colors/dtos/vehicle-color-list.dto';
import { VehicleOdometerTrackingDto } from '../../vehicle-odometer-tracking/dtos/vehicle-odometer-tracking.dto';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../enums/vehicle-drive-train-type.enum';
import { VehicleEmissionsUnitCO2Enum } from '../enums/vehicle-emissions-unit-co2.enum';
import { VehicleEngineSizeUnitEnum } from '../enums/vehicle-engine-size-unit.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehicleOdometerUnitEnum } from '../enums/vehicle-odometer-unit.enum';
import { VehiclePowerPlantTypeEnum } from '../enums/vehicle-power-plant-type.enum';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Vehicle DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleListDto extends BaseDto {
  uuid!: string;
  vin!: string;
  engineNumber?: string | null;
  licensePlate?: string | null;
  odometerUnit?: VehicleOdometerUnitEnum | null;
  lastOdometerTracking?: VehicleOdometerTrackingDto | null;
  type!: VehicleTypeEnum;
  status!: VehicleStatusEnum;
  make?: VehicleMakeListDto | null;
  model?: VehicleModelListDto | null;
  year?: number | null;
  seats?: number | null;
  series?: string | null;
  trim?: string | null;
  exteriorColor?: VehicleColorListDto | null;
  interiorColor?: VehicleColorListDto | null;
  bodyType!: VehicleBodyTypeEnum;
  fuelType?: VehicleFuelTypeEnum | null;
  transmissionType?: VehicleTransmissionTypeEnum | null;
  driveTrainType?: VehicleDriveTrainTypeEnum | null;
  primaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  secondaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  engineSizeUnit?: VehicleEngineSizeUnitEnum | null;
  engineSize?: number | null;
  engineOutput?: number | null;
  engineTurbine?: boolean | null;
  averageEmissionsCO2?: number | null;
  emissionsUnitCO2?: VehicleEmissionsUnitCO2Enum | null;
  electricMotorOutput?: number | null;
  allocation!: VehicleAllocationEnum;
  supplier?: SupplierListDto | null;
  location?: LocationListDto | null;
  vehicleCategory?: VehicleCategoryListDto | null;
  purchasedAt?: Date | null;
  purchaseListPrice?: number | null;
  purchasePaidPrice?: number | null;
  tags?: TagListDto[] | null;
  statusTracking?: StatusTrackingDto<VehicleStatusEnum>[] | null;
}
